// import React, { useState, useEffect } from 'react';
// import apiClient from '../../Api/apiClient';
// import { PHOTO_BASE_URL } from '../../Api/config';
// import Swal from 'sweetalert2';


// const ProfilePage = () => {
//     const [profileData, setProfileData] = useState({
//         name: '',
//         client_photo: null,
//         review: ''
//     });
//     const [profileImage, setProfileImage] = useState(null);
//     const [profileId, setProfileId] = useState(null);

//     // Fetch profile data
//     useEffect(() => {
//         const fetchProfileData = async () => {
//             try {
//                 const response = await apiClient.get('/user/profile');
//                 const data = response.data.data;

//                 setProfileId(data.id);


//                 setProfileData({
//                     name: data.full_name || '',
//                     review: data.review || '',
//                     client_photo: data.client_photo || null,
//                 });

//                 setProfileImage(data.client_photo ? `${PHOTO_BASE_URL}${data.client_photo}` : null);
//             } catch (error) {
//                 console.error('Error fetching profile data:', error);
//             }
//         };

//         fetchProfileData();
//     }, []);

//     // Handle form submit (POST request)
//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (!profileImage) {
//             Swal.fire({
//                 title: 'Success!',
//                 text: 'The preference was updated successfully.',
//                 icon: 'success',
//                 confirmButtonText: 'OK',
//                 customClass: {
//                     popup: 'w-96 h-auto p-3',
//                     title: 'text-lg',
//                     content: 'text-xs',
//                     confirmButton:
//                         'bg-DefaultColor text-white px-4 py-1 text-sm rounded-md',
//                 },
//             });
//             return;
//         }

//         const formData = new FormData();
//         formData.append('name', profileData.name);
//         formData.append('review', profileData.review);

//         if (profileImage && typeof profileImage !== 'string') {
//             formData.append('client_photo', profileImage);
//         }

//         try {
//             // Update the profile using POST request
//             const response = await apiClient.post(`/user/feedback`, formData, {
//                 headers: {
//                     'Content-Type': 'multipart/form-data',
//                 }
//             });

//             // Success Message
//             const backendMessage = response.data.message || "Profile updated successfully!";

//             Swal.fire({
//                 title: 'Success!',
//                 text: backendMessage,
//                 icon: 'success',
//                 confirmButtonText: 'OK',
//                 customClass: {
//                     popup: 'w-96 h-auto p-3',
//                     title: 'text-lg',
//                     content: 'text-xs',
//                     confirmButton: 'bg-DefaultColor text-white px-4 py-1 text-sm rounded-md',
//                 },
//             });
//         } catch (error) {
//             console.error('Error updating profile:', error);

//             // Check if error response exists
//             const backendMessage =
//                 error.response?.data?.message || "Something went wrong! Please try again.";

//             Swal.fire({
//                 title: 'Error!',
//                 text: backendMessage,
//                 icon: 'error',
//                 confirmButtonText: 'Try Again',
//                 customClass: {
//                     popup: 'w-96 h-auto p-3',
//                     title: 'text-lg',
//                     content: 'text-xs',
//                     confirmButton: 'bg-DefaultColor text-white px-4 py-1 text-sm rounded-md',
//                 },
//             });
//         }

//     };

//     // Handle image change (set profile image)
//     const handleImageChange = (e) => {
//         const file = e.target.files[0];
//         if (file) {
//             setProfileImage(file); // Store the file object itself for upload
//         }
//     };

//     return (
//         <div className='mt-36 md:mt-36 md:py-10 py-4 md:p-0 p-2 text-xs'>
//             <form onSubmit={handleSubmit} className='w-full max-w-md mx-auto bg-white border p-6 rounded-lg shadow-md '>
//                 {/* Profile Image */}
//                 <div className='flex justify-center'>
//                     <div className='w-24 h-24 rounded-full overflow-hidden bg-gray-200'>
//                         {profileImage ? (
//                             <img src={typeof profileImage === 'string' ? profileImage : URL.createObjectURL(profileImage)} alt='Profile' className='w-full h-full object-cover' />
//                         ) : (
//                             <div className='flex items-center justify-center w-full h-full'>
//                                 <span className='text-gray-400'>No Image</span>
//                             </div>
//                         )}
//                     </div>
//                 </div>
//                 <div className='mt-2'>
//                     <label className='block  font-semibold text-gray-700'>Upload Image</label>
//                     <input
//                         type='file'
//                         onChange={handleImageChange}
//                         className='mt-2 p-2 border border-gray-300 rounded-md w-full'
//                         required={!profileImage}
//                     />
//                 </div>

//                 {/* Name */}
//                 <div className='mt-3'>
//                     <label className='block  font-semibold text-gray-700'>Name</label>
//                     <input
//                         type='text'
//                         value={profileData.name}
//                         onChange={(e) => setProfileData({ ...profileData, name: e.target.value })}
//                         className='mt-2 p-2 border border-gray-300 rounded-md w-full'
//                     />
//                 </div>

//                 {/* Feedback */}
//                 <div className='mt-3'>
//                     <label className='block  font-semibold text-gray-700'>Your Feedback</label>
//                     <textarea
//                         value={profileData.feedback}
//                         onChange={(e) => setProfileData({ ...profileData, feedback: e.target.value })}
//                         rows="2"
//                         className='mt-2 p-2 border border-gray-300 rounded-md w-full'
//                         required
//                     ></textarea>
//                 </div>

//                 {/* Submit Button */}
//                 <div className='mt-3 flex justify-end'>
//                     <button type='submit' className='px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600'>
//                         Submit Changes
//                     </button>
//                 </div>
//             </form>
//         </div>
//     );
// };

// export default ProfilePage;


import React, { useState, useEffect } from 'react';
import apiClient from '../../Api/apiClient';
import { PHOTO_BASE_URL } from '../../Api/config';
import Swal from 'sweetalert2';

const ProfilePage = () => {
    const [profileData, setProfileData] = useState({
        name: '',
        client_photo: null,
        review: ''
    });
    const [profileImage, setProfileImage] = useState(null);
    const [profileId, setProfileId] = useState(null);

    // Fetch profile data
    useEffect(() => {
        const fetchProfileData = async () => {
            try {
                const response = await apiClient.get('/user/profile');
                const data = response.data.data;

                setProfileId(data.id);

                setProfileData({
                    name: data.full_name || '',
                    review: data.review || '',
                    client_photo: data.client_photo || null,
                });

                setProfileImage(data.client_photo ? `${PHOTO_BASE_URL}${data.client_photo}` : null);
            } catch (error) {
                console.error('Error fetching profile data:', error);
            }
        };

        fetchProfileData();
    }, []);

    // Handle form submit (POST request)
    const handleSubmit = async (e) => {
        e.preventDefault();

        // If there's no new image to upload
        if (!profileImage) {
            Swal.fire({
                title: 'Success!',
                text: 'The preference was updated successfully.',
                icon: 'success',
                confirmButtonText: 'OK',
                customClass: {
                    popup: 'w-96 h-auto p-3',
                    title: 'text-lg',
                    content: 'text-xs',
                    confirmButton: 'bg-DefaultColor text-white px-4 py-1 text-sm rounded-md',
                },
            });
            return;
        }

        const formData = new FormData();
        formData.append('name', profileData.name);
        formData.append('review', profileData.review);

        if (profileImage && typeof profileImage !== 'string') {
            formData.append('client_photo', profileImage);
        }

        try {
            // Update the profile using POST request
            const response = await apiClient.post(`/user/feedback`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            });

            // Success Message
            const backendMessage = response.data.message || "Profile updated successfully!";

            Swal.fire({
                title: 'Success!',
                text: backendMessage,
                icon: 'success',
                confirmButtonText: 'OK',
                customClass: {
                    popup: 'w-96 h-auto p-3',
                    title: 'text-lg',
                    content: 'text-xs',
                    confirmButton: 'bg-DefaultColor text-white px-4 py-1 text-sm rounded-md',
                },
            });
        } catch (error) {
            console.error('Error updating profile:', error);

            // Check if error response exists
            const backendMessage =
                error.response?.data?.message || "Something went wrong! Please try again.";

            Swal.fire({
                title: 'Error!',
                text: backendMessage,
                icon: 'error',
                confirmButtonText: 'Try Again',
                customClass: {
                    popup: 'w-96 h-auto p-3',
                    title: 'text-lg',
                    content: 'text-xs',
                    confirmButton: 'bg-DefaultColor text-white px-4 py-1 text-sm rounded-md',
                },
            });
        }
    };
    
    
    
    

    // Handle image change (set profile image)
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setProfileImage(file); // Store the file object itself for upload
        }
    };

    return (
        <div className='mt-36 md:mt-36 md:py-10 py-4 md:p-0 p-2 text-xs'>
            <form onSubmit={handleSubmit} className='w-full max-w-md mx-auto bg-white border p-6 rounded-lg shadow-md '>
                {/* Profile Image */}
                <div className='flex justify-center'>
                    <div className='w-24 h-24 rounded-full overflow-hidden bg-gray-200'>
                        {profileImage ? (
                            <img src={typeof profileImage === 'string' ? profileImage : URL.createObjectURL(profileImage)} alt='Profile' className='w-full h-full object-cover' />
                        ) : (
                            <div className='flex items-center justify-center w-full h-full'>
                                <span className='text-gray-400'>No Image</span>
                            </div>
                        )}
                    </div>
                </div>

                {/* Upload Image */}
        
                <div className='mt-2'>
                    <label className='block font-semibold text-gray-700'>Upload Image</label>
                    <input
                        type='file'
                        onChange={handleImageChange}
                        className='mt-2 p-2 border border-gray-300 rounded-md w-full'
                        required={!profileImage}
                        accept='.jpg, .jpeg, .png' // Restricting file types to jpg, jpeg, png
                    />
                </div>


                {/* Name */}
                <div className='mt-3'>
                    <label className='block font-semibold text-gray-700'>Name</label>
                    <input
                        type='text'
                        value={profileData.name}
                        onChange={(e) => setProfileData({ ...profileData, name: e.target.value })}
                        className='mt-2 p-2 border border-gray-300 rounded-md w-full'
                    />
                </div>

                {/* Feedback */}
                <div className='mt-3'>
                    <label className='block font-semibold text-gray-700'>Your Feedback</label>
                    <textarea
                        value={profileData.review} // Use 'review' here to match the field name
                        onChange={(e) => setProfileData({ ...profileData, review: e.target.value })}
                        rows="2"
                        className='mt-2 p-2 border border-gray-300 rounded-md w-full'
                        required
                    ></textarea>
                </div>

                {/* Submit Button */}
                <div className='mt-3 flex justify-end'>
                    <button type='submit' className='px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600'>
                        Submit Changes
                    </button>
                </div>
            </form>
        </div>
    );
};

export default ProfilePage;
